module.exports = __webpack_public_path__ + "img/razzo-head-page-2.7d94c1ff.webp";